import { createTimesheetUnlocksItem } from "components/timesheet/unlock/api";
import { queryClient } from "utils/react-query";
import { selectUser } from "store";
import { timesheetKeys } from "components/timesheet/queries";
import { toast } from "sonner";
import { useSelector } from "react-redux";

export function useUnlockTimesheet() {
  const user = useSelector(selectUser);

  const syncTimesheetUnlock = async (date, justification) => {
    try {
      if (!date || !user?.id) {
        throw new Error("Date and user ID are required");
      }

      try {
        const resp = await createTimesheetUnlocksItem({
          item: {
            employee: user.id,
            date,
            justification,
          },
        });

        queryClient.setQueryData(timesheetKeys.unlock(date), (old) =>
          old ? [resp, ...old] : [resp]
        );

        toast.success("Unlocked successfully");
      } catch (error) {
        throw error;
      }

      return {
        success: true,
      };
    } catch (error) {
      console.error("Error unlocking day:", error);
      toast.error("Failed to unlock");
      return {
        success: false,
        error,
      };
    }
  };

  return {
    syncTimesheetUnlock,
  };
}
